// src/pages/Projects.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";
import CategoryTabs from "../components/CategoryTabs";
import ProjectGrid from "../components/ProjectGrid";

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.25,
      delayChildren: 0.1,
    },
  },
};

const titleVariants = {
  hidden: { opacity: 0, y: -40, scale: 0.9 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.7, type: "spring", bounce: 0.4 },
  },
};

const tabsVariants = {
  hidden: { opacity: 0, x: -60, rotate: -5 },
  show: {
    opacity: 1,
    x: 0,
    rotate: 0,
    transition: { duration: 0.7, type: "tween", ease: "easeOut" },
  },
};

const gridVariants = {
  hidden: { opacity: 0, y: 60, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.8, type: "spring", bounce: 0.3 },
  },
};

const CATEGORIES = [
  { id: "Residential", label: "Residential", count: 2 },
  { id: "Commercial", label: "Commercial", count: 1 },
  { id: "Hospitality", label: "Hospitality", count: 1 },
  { id: "Industrial", label: "Industrial", count: 1 },
  { id: "Hospital", label: "Hospital", count: 1 },
  { id: "Automobile", label: "Automobile", count: 1 },
];

export default function Projects({ noMargin }) {
  const [activeCategory, setActiveCategory] = useState("Residential");

  return (
    <motion.div
      className="min-h-screen bg-[var(--bg2)] py-20 px-4"
      style={noMargin ? undefined : { marginTop: "90px" }}
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.h1
        variants={titleVariants}
        className="text-4xl md:text-5xl font-bold text-center mb-12 text-white/90 tracking-[0.2em]"
        viewport={{ once: true, amount: 0.2 }}
      >
        Our Projects
      </motion.h1>

      <motion.div variants={tabsVariants} viewport={{ once: true, amount: 0.2 }}>
        <CategoryTabs
          categories={CATEGORIES}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />
      </motion.div>

      <motion.div variants={gridVariants} viewport={{ once: true, amount: 0.2 }}>
        <ProjectGrid category={activeCategory} />
      </motion.div>
    </motion.div>
  );
}
